import cx from "classnames";

export function Header1({ className, children }: { className?: string; children?: React.ReactNode }) {
  return (
    <h1 className={cx("mb-4 mt-4 text-xl sm:text-2xl text-slate-900 font-bold text-center", className)}>{children}</h1>
  );
}

export function P({ className, children }: { className?: string; children?: React.ReactNode }) {
  return (
    <p className={cx("mx-auto text-slate-700 text-center text-balance text-[12px] w-[80%] sm:w-[380px]", className)}>
      {children}
    </p>
  );
}
